import React from "react";
import { Link } from "react-router-dom";
import GlobalStyle from "./GlobalStyle";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Scene3D from "./Scene3D";
import { Reveal, useSEO } from "./UIKit";

export default function PageShell({
  onAuthClick,
  eyebrow,
  title,
  lede,
  sceneMode,
  sceneData,
  seoTitle,
  seoDescription,
  children,
}) {
  useSEO({ title: seoTitle, description: seoDescription });

  return (
    <div className="bb-root">
      <GlobalStyle />
      <Navbar onAuthClick={onAuthClick} />

      <header className="page-hero">
        <Scene3D mode="particles" className="page-hero-bg" />
        <div className="page-hero-inner">
          <Link to="/" className="back-link">
            <span className="back-link-arrow">←</span> Back to home
          </Link>
          {eyebrow && (
            <Reveal delay={40} className="eyebrow">
              {eyebrow}
            </Reveal>
          )}
          <Reveal as="h1" delay={80} className="page-title">
            {title}
          </Reveal>
          {lede && (
            <Reveal as="p" delay={140} className="page-lede">
              {lede}
            </Reveal>
          )}
        </div>
        {sceneMode && (
          <Reveal delay={100} className="page-hero-scene">
            <Scene3D mode={sceneMode} data={sceneData} />
          </Reveal>
        )}
      </header>

      <main className="page-body">{children}</main>
      <Footer />
    </div>
  );
}